import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { User } from '@/models/user'
import { clearAuthTokenCookie } from '@/shared/authCookies'

export interface AuthState {
  logged: boolean
  unlogged: boolean
  user: User | null
}

const initialState: AuthState = {
  logged: false,
  unlogged: true,
  user: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logged(state, action) {
      state.logged = true
      state.unlogged = false
      state.user = action.payload
    },
    unlogged(state) {
      state.logged = false
      state.unlogged = true
      state.user = null
      clearAuthTokenCookie()
    },
    updateCompanyStatus(state, action: PayloadAction<string>) {
      if (state.user?.company) {
        state.user.company.status = action.payload
      }
    },
    updateLoggedUser(state, action: PayloadAction<User>) {
      state.user = action.payload
      state.logged = true
      state.unlogged = false
    },
  },
})

export const { logged, unlogged, updateCompanyStatus, updateLoggedUser } =
  authSlice.actions

export default authSlice.reducer
